import React from 'react';

export default function MediaGridSkeleton() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-4 pt-2">
      {Array.from({ length: 14 })?.map((_, i) => (
        <div key={`skeleton-${i + 1}`} className="card-elevated overflow-hidden">
          <div className="skeleton aspect-[2/3]" />
          <div className="p-2.5 flex flex-col gap-2">
            <div className="skeleton h-3 w-full rounded" />
            <div className="skeleton h-3 w-3/4 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}